<template>
  <v-card-text>
    <v-radio-group @change="calculateValue()" v-model="hourType">
      <v-radio color="success" value="every">
        <template v-slot:label>
          <div>
            <div class="d-flex align-center">
              Every
              <input style="width: 20px;" :class="{ 'error--text': !validation.every.isValid, 'ml-2 py-1 pl-1 cron-input': true}" disabled value="*/" />
              <input @input="calculateValue()" @keydown.space.prevent style="width: 50px;" :class="{ 'error--text': !validation.every.isValid, 'mr-2 py-1 pr-1 cron-input': true }" type="number" v-model.number="val.every" hide-details />
              {{ val.every == 1 ? 'hour' : 'hours' }}
            </div>
            <div class="caption error--text" v-if="!validation.every.isValid">{{ validation.every.message}}</div>
          </div>
        </template>
      </v-radio>
      <v-radio color="success" value="atSpecific">
        <template v-slot:label>
          <div class="d-flex align-center">
            At <input @input="calculateValue()" @keydown.space.prevent style="width: 50px;" class="mx-2 pa-1 cron-input" type="number" min="0" max="60" v-model.number="val.atSpecific" hide-details />
            {{ (val.atSpecific < 12) ? 'AM' : 'PM' }}
          </div>
        </template>
      </v-radio>
      <v-radio color="success" value="betweenHours">
        <template v-slot:label>
          <div class="d-flex align-center">
            Between
            <input @input="calculateValue()" @keydown.space.prevent style="width: 50px;" class="mx-2 pa-1 cron-input" type="number" v-model.number="val.betweenHoursStart" />
            {{ (val.betweenHoursStart < 12) ? 'AM' : 'PM' }}
            and
            <input @input="calculateValue()" @keydown.space.prevent style="width: 50px;" class="mx-2 pa-1 cron-input" type="number" v-model.number="val.betweenHoursEnd" hide-details />
            {{ (val.betweenHoursEnd < 12) ? 'AM' : 'PM' }}
          </div>
        </template>
      </v-radio>
      <v-radio color="success" value="custom">
        <template v-slot:label>
          <div class="d-flex align-center">
            A custom, comma-delimited combination of the above:
            <input @input="calculateValue()" @keydown.space.prevent style="width: 200px; text-align: left;" class="mx-2 pa-1 cron-input" v-model="val.custom" hide-details />
          </div>
        </template>
      </v-radio>
    </v-radio-group>
  </v-card-text>
</template>

<script>
  const everyRegexLax = /^(\*)([^\s^\,]*)$/g
  const everyRegexCorrect = /^(\*)(\/([0-9]|1[0-9]|2[0-3]))?$/g

  const atSpecificLax = /^(\d)*$/g
  const atSpecificCorrect = /^([0-9]|1[0-9]|2[0-3])$/g

  const betweenHoursLax = /^([\d]*)-([\d]*)$/g
  const betweenHoursCorrect = /^([0-9]|1[0-9]|2[0-3])-([0-9]|1[0-9]|2[0-3])$/g

  const customLax = /^((\d+,)+\d+|(\d+-\d+,?)|\d+|(\*(\/\d+)?),?)+$/g
  const customCorrect = /^(([0-9]|1[0-9]|2[0-3]+,)+[0-9]|1[0-9]|2[0-3]+|([0-9]|1[0-9]|2[0-3]+-[0-9]|1[0-9]|2[0-3]+,?)|[0-9]|1[0-9]|2[0-3]+|(\*(\/[0-9]|1[0-9]|2[0-3]+)?),?)+$/g

  const normalizeOutput = (val) => val.toString().replace(' ', '')

  export default {
    props: {
      value: [String],
    },
    data: () => ({
      hourType: 'every',
      validation: {
        every: {
          isValid: true,
          message: 'Invalid syntax',
        },
        atSpecific: {
          isValid: true,
        },
        betweenHours: {
          isValid: true,
        },
        custom: {
          isValid: true,
        },
      },
      val: {
        every: 5,
        atSpecific: 10,
        betweenHoursStart: 10,
        betweenHoursEnd: 25,
        custom: '*/10,15-20',
      },
      output: null,
    }),
    watch: {
      value: {
        immediate: true,
        handler(val) {
          Object.values(this.validation).forEach(item => item.isValid = true)
          let match

          if (this.hourType != 'custom') {
            match = val.match(everyRegexLax)
            if (match) {
              this.hourType = 'every'
              match = val.match(everyRegexCorrect)
              if (!match) this.validation.every.isValid = false

              let normalized = val.replace('*', '')
              if (normalized.trim().length == 0) normalized = '1'
              else normalized = normalized.replace('/', '')

              this.val.every = normalized
              return
            }

            match = val.match(atSpecificLax)
            if (match) {
              this.hourType = 'atSpecific'
              this.val.atSpecific = val
              match = val.match(atSpecificCorrect)
              if (!match) this.validation.atSpecific.isValid = false
              return
            }

            match = val.match(betweenHoursLax)
            if (match) {
              this.hourType = 'betweenHours'
              let split = val.split('-')
              this.val.betweenHoursStart = split[0]
              this.val.betweenHoursEnd = split[1]
              match = val.match(betweenHoursCorrect)
              if (!match) this.validation.betweenHours.isValid = false
              return
            }
          }

          match = val.match(customLax)
          if (match) {
            this.dayType = 'custom'
            this.val.custom = val

            match = val.match(customCorrect)
            if (!match) this.validation.custom.isValid = false
            return
          } else {
            this.validation.custom.isValid = false
          }
        },
      },
      output(val) {
        this.$emit('input', val)
      },
      validation: {
        deep: true,
        handler(val) {
          let error = Object.values(val).some(item => !item.isValid)
          this.$emit('isValid', !error)
        },
      },
    },
    methods: {
      calculateValue() {
        switch (this.hourType) {
        case 'every':
          this.output = '*/' + normalizeOutput(this.val.every)
          break
        case 'atSpecific':
          this.output = normalizeOutput(this.val.atSpecific.toString())
          break
        case 'betweenHours':
          this.output = normalizeOutput(this.val.betweenHoursStart + '-' + this.val.betweenHoursEnd)
          break
        case 'custom':
          this.output = normalizeOutput(this.val.custom.toString())
          break
        default:
          this.output = '*'
          break
        }
      },
    },
  }
</script>

<style scoped>
  .cron-input {
    background-color: #f3f3f3;
    flex-grow: 0;
    text-align: center;
  }
</style>